import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultFilmActorsDisplayText = {
    label: 'Cast'
};
export const filmActorsDisplayTextValidatorSchema = {
    label: Validator.optional(nonEmptyStringValidator)
};
export const filmActorsDisplayTextValidator = Validator.object(filmActorsDisplayTextValidatorSchema);
